<template>
  <div><MapShow ref="mapshow"></MapShow></div>
</template>

<script>
// @ is an alias to /src
import { test } from "@/api/test.js";
import MapShow from "@/components/map/index.vue";
export default {
  name: "Home",
  components: {
    MapShow,
  },
  data() {
    return {
      activeIndex: "1",
    };
  },
  mounted() {
    // this.$loading()
    // test({id:1})
    this.$error("dsd");

    var loading = this.$loading();
    console.log();

    this.$nextTick(() => {
      // 以服务的方式调用的 Loading 需要异步关闭
      setTimeout(() => {
        loading.close();
      }, 2000);
    });
    this.$refs.mapshow.setLatLon([
      {
        longitude: 116.339924,
        latitude: 39.887222,
      },
      {
        longitude: 113.637288,
        latitude: -0.238086,
      },
      {
        longitude: 80.941975,
        latitude: 7.126281,
      },
      {
        longitude: 45.771303,
        latitude: -24.327365,
      },
      {
        longitude: 49.199037,
        latitude: -13.795714,
      },
      {
        longitude: 121.580403,
        latitude: 24.829903,
      },
      {
        longitude: 7.2347,
        latitude: 5.466492,
      },
      {
        longitude: 120.731706,
        latitude: 22.037619,
      },
      {
        longitude: 167.873353,
        latitude: -46.999204,
      },
      {
        longitude: 143.154115,
        latitude: 43.348919,
      },
      {
        longitude: 109.695253,
        latitude: 19.170814,
      },
    ]);
  },
  methods: {
    handleOpen() {},
    handleClose() {},
  },
};
</script>
<style scoped>
.container {
  width: 100%;
  height: 100vh;
}
</style>
